/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Button_Group_Nested_DropdownInputs */



/**
* | output |
* | --- |
* | "Button group with nested dropdown" |
*
* @param {Button_Group_Nested_DropdownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const button_group_nested_dropdown = /** @type {((inputs?: Button_Group_Nested_DropdownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Button_Group_Nested_DropdownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe de boutons avec menu déroulant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schaltflächengruppe mit verschachteltem Dropdown-Menü")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di pulsanti con menu a discesa annidato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа кнопок с вложенным выпадающим списком")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de botones con menú desplegable anidado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("带有嵌套下拉菜单的按钮组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ネストされたドロップダウンを持つボタングループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नेस्टेड ड्रॉपडाउन के साथ बटन समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de botões com lista suspensa aninhada")
	return /** @type {LocalizedString} */ ("Button group with nested dropdown")
});